import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
// TODO: leer variable current_language de localStorage, también debe estar almacenada en DB
const currentLanguage = 'es'
const messages = {}
let translations = {}

const translationFiles = require.context(
  './es/',
  true,
  /[A-Za-z0-9-_,\s]+\.(js)$/
)

translationFiles.keys().forEach(key => {
  translations = Object.assign(translations, translationFiles(key).default)
})

messages[currentLanguage] = translations

const i18n = new VueI18n({
  locale: currentLanguage,
  fallbackLocale: 'es',
  messages
})

export default i18n
